// API Reference: https://www.wix.com/velo/reference/api-overview/introduction
// “Hello, World!” Example: https://learn-code.wix.com/en/article/1-hello-world
// import { login } from 'backend/data.js';
import wixUsers from 'wix-users';
import wixLocation from 'wix-location';
import wixData from 'wix-data';
$w.onReady(function () {
	// Write your JavaScript here

	let user = wixUsers.currentUser;
	let id = user.id;  
	wixData.query("customers").hasSome("lakoh", id).find()
			.then((res) => {
				if (res.length>0) {
					
				
			let url =	res.items[0]._id
// console.log(user);
// user.getEmail()
//   .then( (email) => {
//     let userEmail = email;      // "user@something.com"
 wixLocation.to( "/dashboard/"+ url)
 }else{
	 
 }
  } );
// 	if (user.get === true) {
// 		let userId = user.id;
// 		let isLoggedIn = user.loggedIn;
// 		wixData.query("customers")
// 			.eq("_owner", userId)
// 			.find()
// 			.then((res) => {
             
// wixLocation.to( "/dashboard/"+ res.items[0]._id)

//  })
		
	// }
	// To select an element by ID use: $w("#elementID")

	// Click "Preview" to run your code
});

// export function button1_click(event) {
// let emels  = $w('#input1').value,
// sisma = $w('#input2').value;


//  wixData.insert("Customers", {"mail": emels, "sisma":sisma }).then((res)=>{
// wixLocation.to( "/customers/"+ res._id)

//  })
// //  let lakoh =
// //  })
 
//  	// This function was added from the Properties & Events panel. To learn more, visit http://wix.to/UcBnC-4
// 	// Add your code for this event here: 
// }